import { createContext, useState, useEffect, useContext } from 'react';
import { AccountContext } from './account-context'
import { ErrorContext } from './error-context'
import { TasksContext } from './tasks-context';


const TasksCounterContext = createContext(null);

const TasksCounterProvider = ({ children }) => {

    const [account, setAccount] = useContext(AccountContext);
    const [tasks, setTasks] = useContext(TasksContext);
    const [localAccount, setLocalAccount] = useState(account);

    const [error, setError] = useContext(ErrorContext);
    const [counter, setCounter] = useState([[], [], [], [], [], [], [], [], [], []]);

    const isNew = (task) =>{
        return !task.isRead;
    }

    const isOverdue = (task) =>{
        return task.dateTo && new Date(task.dateTo) < new Date();
    }

    const isFuture = (task) =>{
        return task.dateFrom && new Date(task.dateFrom) > new Date();
    }

    const isExecute = (task) =>{
        return task.dateFrom && new Date(task.dateFrom) <= new Date();
    }

    const isRed = (task) =>{
        return task.color === 1 && !isFuture(task);
    }
    
    const isYellow = (task) =>{
        return task.color === 2 && !isFuture(task);
    }
    
    const isGreen = (task) =>{
        return task.color === 3 && !isFuture(task);
    }
    
    const isWithoutPriority = (task) =>{
        return (!task.color || (task.color != 1 && task.color != 2 && task.color != 3)) && !isFuture(task);
    }

    useEffect(() => {
        setLocalAccount(account);
    }, [account]);

    useEffect(() => {

        if (!localAccount)
            return;

        if (!tasks)
            return;

        // Complete = 0,
        // New = 1,
        // Overdue = 2,
        // Future = 3,
        // Uncomplete = 4,
        // Execute = 5,
        // RedPriority = 6,
        // YellowPriority = 7,
        // GreenPriority = 8,
        // WithoutPriority = 9,

        setCounter(prevCounter => {

            let counterUpd = [...prevCounter];

            counterUpd[1] = tasks.filter(a => isNew(a)).map(a=>a.id);
            counterUpd[2] = tasks.filter(a => isOverdue(a)).map(a=>a.id);
            counterUpd[3] = tasks.filter(a => isFuture(a)).map(a=>a.id);
            counterUpd[5] = tasks.filter(a => isExecute(a)).map(a=>a.id);
            counterUpd[6] = tasks.filter(a => isRed(a)).map(a=>a.id);
            counterUpd[7] = tasks.filter(a => isYellow(a)).map(a=>a.id);
            counterUpd[8] = tasks.filter(a => isGreen(a)).map(a=>a.id);
            counterUpd[9] = tasks.filter(a => isWithoutPriority(a)).map(a=>a.id);
            
            return counterUpd;

        });

    }, [localAccount, tasks]);

    

    return (
        <TasksCounterContext.Provider value={[counter, setCounter]}>
            {children}
        </TasksCounterContext.Provider>
    )
}

export { TasksCounterContext, TasksCounterProvider };

